__turbopack_context__.v({
  "annotationItem": "AnnotationLayer-module__UW4MIq__annotationItem",
  "annotationLayer__selectionBox": "AnnotationLayer-module__UW4MIq__annotationLayer__selectionBox",
});
